const services = [
  {
    image: '/images/lvv-gecertificeerd.webp',
    title: 'LVV-gecertificeerde registervertrouwenspersonen',
    text: 'Onze vertrouwenspersonen zijn altijd LVV-gecertificeerde registervertrouwenspersonen. Keuze voor een man of vrouw, in het Nederlands of Engels. Online, telefonisch of op een neutrale locatie in de buurt — nooit op locatie van de organisatie.',
  },
  {
    image: '/images/gratis-communicatie-kit.webp',
    title: 'Het PuntUit-spel',
    text: 'Een fysiek spel met stellingen over omgangsvormen. Spelers reageren met groene, gele, oranje en rode kaarten en maken het onderwerp op een laagdrempelige, constructieve en leuke manier bespreekbaar.',
  },
  {
    image: '/images/gratis-spreekuur.png',
    title: 'Gratis online spreekuur',
    text: 'Een laagdrempelige tussenstap zonder verplichtingen en zonder directe kosten voor de organisatie. In meer dan 70% van de gevallen is het spreekuur voldoende om het probleem zelf verder op te lossen.',
  },
  {
    image: '/images/hulpvraag-platform.webp',
    title: '24/7 zelfhulpplatform: praatuit.nl',
    text: 'Altijd toegang tot achtergrondinformatie, uitleg over de vertrouwenspersoon, alle contactmogelijkheden (mail, telefoon, WhatsApp en spreekuur) en een agenda om direct een afspraak in te plannen.',
  },
  {
    image: '/images/early-awareness-tool.webp',
    title: 'Early Awareness Tool',
    text: 'Via praatuit.nl ziet PuntUit op geaggregeerd niveau welke onderwerpen binnen een organisatie extra aandacht krijgen, zonder dat dit naar personen is te herleiden. Die signalen helpen om scherper te rapporteren en eerder bij te sturen.',
  },
  {
    image: '/images/24-7-beschikbaar.webp',
    title: 'Periodieke awareness-mails',
    text: 'Per kwartaal een korte e-mail met een filmpje over een thema rond omgangsvormen. Houdt de aandacht voor omgangsvormen actief en herinnert mensen dat er een vertrouwenspersoon beschikbaar is.',
  },
  {
    image: '/images/jaarlijkse-raportage.webp',
    title: 'Jaarverslag / jaarlijkse rapportage',
    text: 'Eén keer per jaar een jaarverslag over het bezoek aan het zelfhulpplatform, het aantal spreekuurafspraken, de mate van opvolging en aanbevelingen voor de komende periode.',
  },
];

export function ServicesGrid() {
  return (
    <section className="section-padding bg-white">
      <div className="container max-w-6xl">
        <div className="text-center mb-14">
          <p className="text-[#0284c7] text-xs font-semibold uppercase tracking-[0.2em] mb-2">Wat krijg je bij PuntUit?</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Een compleet programma voor bewustwording en preventie.</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map(({ image, title, text }) => (
            <div
              key={title}
              className="bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm"
            >
              <div className="aspect-[3/2] overflow-hidden bg-gray-50">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
